<script lang="ts">
  import { DEFAULT_DEPTH } from '../depth/ops';
  import { t } from '../i18n/index.svelte';
  import { studio } from '../state.svelte';
  import Section from './ui/Section.svelte';
  import Select from './ui/Select.svelte';
  import Slider from './ui/Slider.svelte';
  import Toggle from './ui/Toggle.svelte';

  const d = $derived(studio.depth);
  const fix2 = (v: number) => v.toFixed(2);
</script>

<Section title={t('depth.title')}>
  {#snippet aside()}
    <button class="ghost small" onclick={() => (studio.depth = { ...DEFAULT_DEPTH })}>{t('common.reset')}</button>
  {/snippet}
  <div class="grid2">
    <Toggle label={t('depth.normalize')} bind:checked={d.normalize} />
    <Toggle label={t('depth.invert')} bind:checked={d.invert} testid="depth-invert" />
  </div>
  {#if d.normalize}
    <Slider
      label={t('depth.clip')}
      bind:value={d.clip}
      min={0}
      max={0.1}
      step={0.005}
      format={(v) => `${(v * 100).toFixed(1)}%`}
    />
  {/if}
  <div class="grid2">
    <Slider label={t('depth.far')} bind:value={d.far} min={0} max={0.95} step={0.01} format={fix2} />
    <Slider label={t('depth.near')} bind:value={d.near} min={0.05} max={1} step={0.01} format={fix2} />
  </div>
  <Slider label={t('depth.gamma')} bind:value={d.gamma} min={0.2} max={4} step={0.05} format={fix2} />
  <div class="grid2">
    <Select
      label={t('depth.smoothing')}
      bind:value={d.smoothing}
      options={[
        { value: 'none', label: t('depth.smooth.none') },
        { value: 'bilateral', label: t('depth.smooth.bilateral') },
        { value: 'guided', label: t('depth.smooth.guided') },
      ]}
    />
    {#if d.smoothing !== 'none'}
      <Slider label={t('depth.radius')} bind:value={d.smoothRadius} min={1} max={12} />
    {/if}
  </div>
  <Slider label={t('depth.blur')} bind:value={d.blur} min={0} max={20} step={0.5} />
  <Slider
    label={t('depth.levels')}
    bind:value={d.levels}
    min={0}
    max={32}
    format={(v) => (v < 2 ? t('common.off') : String(v))}
  />
  <div class="grid2">
    <Slider label={t('depth.rangeMin')} bind:value={d.rangeMin} min={0} max={0.9} step={0.01} format={fix2} />
    <Slider label={t('depth.rangeMax')} bind:value={d.rangeMax} min={0.1} max={1} step={0.01} format={fix2} />
  </div>
</Section>

<style>
  .small {
    font-size: 12px;
    padding: 2px 8px;
  }
</style>
